import { tJosa } from '@mathflat/shared/i18n/tJosa'
import { format } from 'date-fns'

import dateUtils from '@/utils/DateUtils'

export type Meridiem = '오전' | '오후'
export type MeridiemParts = { meridiem: Meridiem; hour12: number; minute: number }

export const formatScheduleDate = (date: Date) => dateUtils.toDateString(date, '.')

export const toMeridiemParts = (date: Date): MeridiemParts => {
  const hours = date.getHours()
  return {
    meridiem: hours < 12 ? '오전' : '오후',
    hour12: hours % 12 === 0 ? 12 : hours % 12,
    minute: date.getMinutes(),
  }
}

export const fromMeridiemParts = (day: Date, { meridiem, hour12, minute }: MeridiemParts): Date => {
  const hours = (hour12 % 12) + (meridiem === '오후' ? 12 : 0)
  const result = new Date(day)
  result.setHours(hours, minute, 0, 0)
  return result
}

export const formatScheduleTime = (date: Date) => {
  const { meridiem, hour12 } = toMeridiemParts(date)
  return `${meridiem} ${hour12}:${format(date, 'mm')}`
}

export const formatScheduledToast = (date: Date) =>
  `${formatScheduleDate(date)} ${dateUtils.toKoDayOfWeek(date)}요일\n${formatScheduleTime(date)}분 ${tJosa('출제', '으로/로')} 예약되었습니다.`
